import { render, staticRenderFns } from "./TherapyLogin.vue?vue&type=template&id=4c4fdeef"
import script from "./TherapyLogin.vue?vue&type=script&lang=js"
export * from "./TherapyLogin.vue?vue&type=script&lang=js"
import style0 from "./TherapyLogin.vue?vue&type=style&index=0&id=4c4fdeef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports